import { render, staticRenderFns } from "./power-box.vue?vue&type=template&id=f835cd50&scoped=true&"
import script from "./power-box.vue?vue&type=script&lang=js&"
export * from "./power-box.vue?vue&type=script&lang=js&"
import style0 from "./power-box.vue?vue&type=style&index=0&id=f835cd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f835cd50",
  null
  
)

export default component.exports